import React from 'react'
import { Typography, Image, Table, Tag } from 'antd';
import roadtypeImg from "./roadtype.jpg"
import manuImg from "./menu2.jpg"
const { Title, Paragraph } = Typography;

export default function Lineroad() {
  const dataSource = [
    {
      key: '1',
      name: '机动车道宽度',
      range: '1~100',
      desc: '双向整体机动车道路面宽度，含路缘带。用于一幅路、三幅路，在三幅路中指主道宽度。',
    },
    {
      key: '2',
      name: '左机动车道宽度',
      range: '1~100',
      desc: '单向机动车道路面宽度，含路缘带。用于二幅路、四幅路，在四幅路中指主道宽度。',
    },
    {
      key: '3',
      name: '右机动车道宽度',
      range: '1~100',
      desc: '单向机动车道路面宽度，含路缘带。用于二幅路、四幅路，在四幅路中指主道宽度。',
    },
    {
      key: '4',
      name: '主道设计车速',
      range: '20~120',
      desc: '决定主车道标线类型，40及40以下采用2-4标线，大于40采用6-9标线。',
    },
    {
      key: '5',
      name: '辅道设计车速',
      range: '20~120',
      desc: '决定辅道标线类型，40及40以下采用2-4标线，大于40采用6-9标线。用于三幅路、四幅路。',
    },
    {
      key: '6',
      name: '中央分隔带宽',
      range: '0~20',
      desc: '中央分隔带宽度，含路缘石宽。宽度小于等于2倍路缘石宽度时将不会生成中央分隔带。用于二幅路、四幅路。',
    },
    {
      key: '7',
      name: '中央分隔带缘石高',
      range: '0~1',
      desc: '中央分隔带和侧分隔带路缘石高度。用于二幅路、三幅路、四幅路。',
    },
    {
      key: '8',
      name: '中央缘石宽',
      range: '0.1~0.5',
      desc: '中央分隔带路缘石宽度。用于二幅路、四幅路。',
    },
    {
      key: '9',
      name: '中央缘石倒角半径',
      range: '0~0.5',
      desc: '中央分隔带路缘石倒角半径。用于二幅路、四幅路。',
    },
    {
      key: '10',
      name: '侧分隔带缘石宽',
      range: '0~0.5',
      desc: '侧分隔带缘路缘石宽度。用于三幅路、四幅路。',
    },
    {
      key: '11',
      name: '侧缘石倒角半径',
      range: '0~0.5',
      desc: '侧分隔带路缘石倒角半径。用于三幅路、四幅路。',
    },
    {
      key: '12',
      name: '路缘石倒角半径',
      range: '0~0.5',
      desc: '人行道路缘石倒角半径。',
    },
    {
      key: '13',
      name: '路缘石宽',
      range: '0~0.5',
      desc: '人行道路缘石宽度。',
    },
    {
      key: '14',
      name: '左辅道宽',
      range: '0~50',
      desc: '三幅路和四幅路的左侧辅道宽度，含路缘带。',
    },
    {
      key: '15',
      name: '右辅道宽',
      range: '0~50',
      desc: '三幅路和四幅路的右侧辅道宽度，含路缘带。',
    },
    {
      key: '16',
      name: '侧分隔带宽',
      range: '0~20',
      desc: '侧分隔带宽度，含两侧路缘石。用于三幅路、四幅路。',
    },
    {
      key: '17',
      name: '人行道绿化带宽度',
      range: '0~20',
      desc: '机动车道与人行道之间的绿化带宽度。',
    },
    {
      key: '18',
      name: '人行道宽',
      range: '0~20',
      desc: '道路两侧的人行道宽度。',
    },
    {
      key: '19',
      name: '非机动车道宽',
      range: '0~20',
      desc: '道路两侧的非机动车道宽度。',
    },
    {
      key: '20',
      name: '路肩宽度',
      range: '0~20',
      desc: '道路最外侧靠近道路红线的路肩宽度。',
    },
    {
      key: '21',
      name: '主道单车道宽',
      range: '0~5',
      desc: '定义主道上一条车道的宽度。取值在3~3.75之间有效，否则由程序自动计算车道宽度',
    },
    {
      key: '22',
      name: '辅道单车道宽',
      range: '0~5',
      desc: '定义辅道上一条车道的宽度。取值在3~3.75之间有效，否则由程序自动计算车道宽度。用于三幅路、四幅路。',
    },
  ];

  const columns = [
    {
      title: '参数',
      dataIndex: 'name',
      render: (name)=>{
        return (
          <Tag color={'volcano'} key={name}>
            {name}
          </Tag>
        );
      }
    },
    {
      title: '取值范围',
      dataIndex: 'range',
      key: 'range',
    },
    {
      title: '描述',
      dataIndex: 'desc',
      key: 'desc',
    },
  ];
  return (
    <Typography>
      <Title level={2}>介绍</Title>
      <Paragraph>
        本软件提供三种道路效果图场景，分别为直线路段、十字交叉口和特殊路段，直线路段顾名思义，该场景提供一段直线型的道路模型，长度为500米。在该场景中，
        通过修改道路横断面参数来修改道路模型。可以通过以下两种方式进入直线路段场景：
      </Paragraph>
      <Paragraph>
        <ul>
          <li>
            通过启动菜单<br></br>
            <Image width={100} src={manuImg} />
          </li>
          <li>
            通过主界面上方区域的道路类型下拉列表框<br></br>
            <Image width={200} src={roadtypeImg} />
          </li>
        </ul>
      </Paragraph>
      <Title level={2}>道路横断面参数</Title>
      <Paragraph>
      <Table dataSource={dataSource} columns={columns} pagination={{pageSize:50}}/>;
      </Paragraph>
    </Typography>
  )
}
